export const SPECIFICATION_TYPE = {
    PREREQUISITE: 0,
    OBJECTIVE: 1,
    PUBLIC: 2
};